// axiosInstance.ts
import axios from "axios";
import { store } from "../redux/store";

const axiosInstance = axios.create({
  baseURL: "" // optional
  //   withCredentials: true, // if you use cookies
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      store.dispatch({ type: "LOGOUT" });
      localStorage.clear();
      window.location.href = "/login"; // redirect on 401
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
